import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-lg transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl';
  const variants = {
    primary: 'bg-brand-gold hover:bg-brand-goldLight text-brand-navy',
    outline: 'border-2 border-brand-gold text-brand-gold hover:bg-brand-gold hover:text-brand-navy'
  };
  const classes = `${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`;
  const content = <motion.div whileTap={{
    scale: 0.95
  }} data-id="element-12">
      {children}
    </motion.div>;
  if (href) {
    return <a href={href} className={classes} data-id="element-13">
        {content}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-14">
      {content}
    </button>;
}